import { z } from 'zod';
// The live-updates vocabulary (ADR-074 §2). A CHANGE KIND names one change
// counter of a project: a kind of data held in ems-app's own database, or the
// project's RIGHTS. The list is CLOSED and short on purpose — a new kind is one
// word here plus one column on `change_counters`; a coarse counter can waste a
// read but never miss a change. Data the data plane owns (readings, alarms) has
// no kind: its screens re-ask on the rhythm.
export const CHANGE_KINDS = ['tickets', 'files', 'visits', 'rights'];
export const ChangeKindSchema = z.enum(CHANGE_KINDS);
/** The response header a live read answers with: for each counter the answer
 *  depends on, its name AND the change token the answer reflects — an RFC 8941
 *  dictionary of strings (`tickets="…", visits="…"`). Names and tokens only,
 *  never an id. */
export const CHANGE_TOKENS_HEADER = 'Change-Tokens';
